"use client";
import React from "react";
import { cn } from "@/lib/utils";
import { AuditLinkVaraintProps } from "../types";

const baseStyles = `text-center content-center items-center py-2 justify-center disabled:opacity-25 px-6 underline underline-offset-2`;

function AuditLinkAnchor({
  auditCourseLabel,
  isDisabled,
  onEnroll,
  className = "",
}: AuditLinkVaraintProps) {
  return (
    <button
      className={cn(baseStyles, className)}
      onClick={onEnroll}
      disabled={isDisabled}
    >
      {auditCourseLabel}
    </button>
  );
}

export default AuditLinkAnchor;
